import { Component } from 'react'
import { Form, Button, Table, Modal } from 'react-bootstrap'
import { Donor } from "../../api/OrderRequests/OrderRequestsModel/Donor"

interface PotentialDonorMatchProps {
  potentialDonorMatchList: Donor[]
  onClose: () => void
  onSubmit: (match: Donor) => void
  show?: boolean
}

interface PotentialDonorMatchState {
  selectedDonorMatch?: Donor
}

export default class PotentialDonorMatchModal extends Component<PotentialDonorMatchProps, PotentialDonorMatchState> {
  state = { selectedDonorMatch: undefined }
  selectDonorMatch = (donorMatch: Donor) => this.setState({ selectedDonorMatch: donorMatch })
  render() {
    return (
      <Modal show={ this.props.show } onHide={ this.props.onClose } size="xl" dialogClassName="dark">
        <Modal.Header closeButton>
          <Modal.Title>POTENTIAL DONOR MATCH</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table>
            <thead>
              <tr>
                <th>&nbsp;</th>
                <th>Name</th><th>Existing ID</th><th>Match</th>
              </tr>
            </thead>
            <tbody>
              { this.props.potentialDonorMatchList.map(donorMatch => <tr key={ donorMatch?.CCFPersonnelID } onClick={ () => this.selectDonorMatch(donorMatch) } >
                <td>
                  <Form.Check type="radio" name="CCFPersonnelID" label="" id={ (donorMatch?.PersonID || "").toString() } checked={ this.state.selectedDonorMatch === donorMatch } className="abc-radio abc-radio-primary" onChange={ () => this.selectDonorMatch(donorMatch) } />
                </td>
                <td>{ donorMatch?.FirstName } { donorMatch?.LastName }</td>
                <td>{ donorMatch?.CCFPersonnelID }</td>
                <td>{ donorMatch?.Match }</td>
              </tr>) }
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="font-weight-bold px-4" onClick={() => { this.props.onClose() }}>Create New</Button>
          <Button variant="primary" className="font-weight-bold px-4" onClick={() => { this.props.onSubmit(this.state.selectedDonorMatch!) }} disabled={!this.state.selectedDonorMatch}>Confirm</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}
